import { useCallback, useMemo } from 'react';

import { MarginTransaction, MarginTransactionType } from '@swyftx/margin/build/types';

import { useFetchMarginTransactions } from './useFetchMarginTransactions';

type Props = {
  sortByDesc?: boolean;
  type?: MarginTransactionType[];
};

const useMarginTransactions = ({ sortByDesc = true, type }: Props = { sortByDesc: true }) => {
  const { data, isFetching, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage, isError } =
    useFetchMarginTransactions({ sortByDesc, type });

  const transactions = useMemo(
    (): MarginTransaction[] => data?.pages?.flatMap((p) => p.transactions) || [],
    [data?.pages],
  );

  const getTransactionById = useCallback(
    (id?: string) => {
      if (!transactions || !id) return undefined;
      return transactions.find((d: MarginTransaction) => d.transactionId === id);
    },
    [transactions],
  );

  return {
    transactions,
    getTransactionById,
    hasNextPage,
    fetchNextPage,
    isFetchingNextPage,
    isFetching,
    isLoading,
    isError,
  };
};

export { useMarginTransactions };
